module.exports = __webpack_public_path__ + "static/media/hp_05.bc0b166e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_05.jpg
// module id = 5816
// module chunks = 0